import { CardColorSwatches } from '@apps/card/components/CardColorSwatches';
import type { ColorwayOption } from '@apps/card/routes/CardCustomizer/components/PageJson.types';
import { ChoiceGroup } from '@apps/card/routes/CardCustomizer';
import { useTranslation } from '@shared/core';
import { Box } from '@withjoy/joykit';
import React from 'react';

type Props = Readonly<{
  options?: ReadonlyArray<ColorwayOption>;
  selectedColorwayId?: string;
  onSelect?: (id: string) => void;
  /** Applied only when the selector actually renders (no phantom gap when null). */
  marginBottom?: number;
}>;

/**
 * Shared "Color" swatch selector rendered on the PDP customization pane for
 * every format that carries colorways (print + premium digital). Renders
 * nothing when the template has no colorways or no selection handler.
 */
export const ColorwaySelector = ({ options, selectedColorwayId, onSelect, marginBottom }: Props) => {
  const { tq } = useTranslation('stationery');
  if (!options || selectedColorwayId === undefined || !onSelect) {
    return null;
  }
  return (
    <Box marginBottom={marginBottom}>
      {/* ChoiceGroup supplies the same title + capitalized value eyebrow the foil
          selector uses. No `price` is passed, so no price/"FREE" label renders. */}
      <ChoiceGroup
        value={selectedColorwayId}
        title={tq`Color`}
      >
        <CardColorSwatches
          options={options}
          selectedId={selectedColorwayId}
          onSelect={onSelect}
          size="large"
        />
      </ChoiceGroup>
    </Box>
  );
};
